module.exports = __webpack_public_path__ + "media/images/spinner-803f24369a085e35482e874050e62261.gif";